<app-windowlist [model]="this">
    <div class="row">
        <div class="col-lg-2 pr-lg-0" *ngIf="filterbox">
            <div class="d-none d-lg-block w-100 text-center text-primary">Filtri</div>
            <app-filtercontainer [title]="'Filtra per date o sedi'">
                <app-filterdate [date_type]="100" [class]="'card p-1'" [filter_date]="filter_date" (onSelect)="updateList()"></app-filterdate>
                 <ul class="card small-box list-group p-1 my-2" >
                    <li class="list-group-item pointer" [class.active]="filter_id_cash.value==''" ><span (click)="filter_id_cash.value='';getItems()">Tutte le casse</span> <i class="fa fa-cog float-right" (click)="editCashes=!editCashes"></i></li>
                    <li class="list-group-item text-truncate pointer" *ngFor="let c of cashes" [class.active]="filter_id_cash.value==c.id" >
                        <span (click)="filter_id_cash.value=c.id;getItems()">
                            {{c.name}}
                        </span>
                        <i *ngIf="editCashes" class="text-danger fa fa-delete float-right" (click)="deleteCash(c.id)"></i>
                    </li>
                    <div  *ngIf="cashes.length>2" class="icon"><i class="fa fa-store-alt "></i></div>
                    <li *ngIf="editCashes" class="list-group-item pointer" (click)="addCash()">Aggiungi</li>
                </ul>
                <ng-container *ngIf="checkPermissions('showCreatedFrom') && isModuleEnabled('shops')">
                     <ul class="card small-box list-group p-1 my-2" *ngIf="shops && shops.length>1">
                        <li class="list-group-item pointer" [class.active]="filter_created_from.value==''" (click)="filter_created_from.value='';getItems()">Tutte le sedi</li>
                        <li class="list-group-item text-truncate pointer" *ngFor="let s of shops" [class.active]="filter_created_from.value==s.id" (click)="filter_created_from.value=s.id;getItems()">{{s.name}}</li>
                        <div  *ngIf="shops.length>2" class="icon"><i class="fa fa-store-alt "></i></div>
                    </ul>
                </ng-container>
            </app-filtercontainer>
        </div>
        <div [class.col-lg-10]="filterbox" [class.col-lg-12]="!filterbox" >            
            <div class="row">
                    <div class="col-3" *ngFor="let c of cashesTotal">
                        <div class="card">
                            <div class="card-body text-center">
                                <h5>{{c.name}}</h5>
                                <h2>{{c.balance | currency:"EUR"}}</h2>
                            </div>
                        </div>
                    </div>
                </div>
            <div class="card elevation-0 border-0">
                <ng-container *ngIf="filterbox">
                    <div class="row">
                        <div class="col-lg-5">
                            <div class="input-group input-group-sm m-1">
                                <input type="text" #table_search name="table_search" class="form-control float-right" placeholder="cerca..." [(ngModel)]="filter_search.value" (keyup.enter)="getItems()" [class.alert-info]="filter_search.value!=''">
                                <div class="input-group-append ">
                                    <button type="submit" class="btn btn-default text-primary"  title="Avvia ricerca" (click)="getItems()"><i class="fas fa-search"></i></button>
                                    <button class="btn btn-default text-danger"   title="Annulla ricerca" *ngIf="filter_search.value!=''" (click)="filter_search.value='';getItems();"><span id="searchclear" class="fas fa-times"></span></button>
                                </div>
                            </div>
                        </div>
                        <div class="col-6 col-lg-3">
                            <div class="input-group input-group-sm m-1">
                                <select class="custom-select" [(ngModel)]="filter_id_user.value" (ngModelChange)="getItems()" [class.alert-info]="filter_id_user.value">
                                    <option value="">Tutti gli operatori</option>
                                    <ng-container *ngFor="let u of users">
                                        <option *ngIf="u.enabled" [ngValue]="u.id">{{u.username}}</option>
                                    </ng-container>
                                </select>
                            </div>
                        </div>
                        <div class="col-6 col-lg-4" >
                            <div class="pr-1">
                                <app-windowlistbuttons 
                                [model]="this" 
                                [table]="'cashregister'" 
                                [openDetailExtra]="{'name':'id_address','value':id_address}" 
                                [funs]="[]"
                                ></app-windowlistbuttons>
                            </div>                            
                            <!-- 
                            <button  title="Cestina" *ngIf="filter_status.value == '1'" (click)="trash()" [disabled]="form.value.id.length == 0" class="btn btn-danger btn-xs float-right mx-1 "><i class="far fa-trash-alt"></i></button>
                            <button  title="Elimina" *ngIf="filter_status.value == '2'" (click)="delete()" [disabled]="form.value.id.length == 0" class="btn btn-danger btn-xs float-right mx-1 "><i class="fas fa-trash"></i></button>
                            <button  title="Ripristina" *ngIf="filter_status.value == '2'" (click)="undo()" [disabled]="form.value.id.length == 0" class="btn btn-secondary btn-xs float-right ml-1 "><i class="fas fa-undo"></i></button>
                            <button  title="Esporta" (click)="export()"  class="btn btn-secondary btn-xs float-right ml-1 "><i class="fas fa-file-export"></i></button>
                            <button  title="Aggiungi" (click)="openDetail(null,{'name':'id_address','value':id_address})" class="btn btn-success btn-xs float-right ml-1"><i class="fas fa-plus"></i></button> -->
                        </div>
                    </div>
                </ng-container>


                


                <div *ngIf="!list || list.length==0" class="m-5 text-center text-secondary">
                    <i class="icon fas fa-info-circle mr-2"></i><i>Nessun elemento soddisfa i parametri di ricerca impostati!</i>

                </div>
                <form *ngIf="list && list.length>0" [formGroup]="form">
                    <table class="table table-nowrap table-striped table-sm table-head-fixed m-0 text-sm">
                        <thead>
                            <th>
                                <div #checkboxselectall class="icheck-primary d-inline mr-3">
                                    <input type="checkbox" title="Seleziona tutti"
                                    (change)="onChangeAll($event.target.checked)" />
                                </div>
                            </th>
                            <th>Data
                                <button type="button" class="btn btn-tool" (click)="switchOrdering('c.date')">
                                    <i class="fas fa-sort {{classOrdering('c.date')}}"  ></i>
                                </button>
                            </th>
                            <th>Cassa
                                <button type="button" class="btn btn-tool" (click)="switchOrdering('cs.name')">
                                    <i class="fas fa-sort {{classOrdering('cs.name')}}"  ></i>
                                </button>
                            </th>
                            <th>Descrizione
                                <button type="button" class="btn btn-tool" (click)="switchOrdering('c.description')">
                                    <i class="fas fa-sort {{classOrdering('c.description')}}"  ></i>
                                </button>
                            </th>

                           <!--<th class="text-center">Calcolato
                                <button type="button" class="btn btn-tool" (click)="switchOrdering('c.amount')">
                                    <i class="fas fa-sort {{classOrdering('c.amount')}}"  ></i>
                                </button>
                            </th>-->
                            <th class="text-center">Valore dichiarato
                                <button type="button" class="btn btn-tool" (click)="switchOrdering('c.paid')">
                                    <i class="fas fa-sort {{classOrdering('c.paid')}}"  ></i>
                                </button>
                            </th>

                            <th class="text-center">Valore atteso
                                <button type="button" class="btn btn-tool" (click)="switchOrdering('c.amount')">
                                    <i class="fas fa-sort {{classOrdering('c.amount')}}"  ></i>
                                </button>
                            </th>
                            <th class="text-center">Operatore</th>
                            <th></th>
                        </thead>
                        <tbody>
                        
                            <!-- elemento ripetuto -->
                            <tr *ngFor="let record of list" [class.bg-warning]="verifyDate(record.date)" [class.bg-redlight]="record.id_type==2">
                                <td  title="{{record.date | date:'EEEE'}}">
                                    <div class="icheck-primary d-inline mr-3">
                                        <input type="checkbox" #checkrecord id_record="{{record.id}}"
                                        (change)="onChange(record.id, $event.target.checked)" [checked]="checkedAll"
                                        />
                                    </div>
                                </td>
                                <td>
                                    <a [class.trashed]="record.status == 2" (click)="openDetail(record)">{{record.date | date:'dd/MM/yyyy'}}</a>
                                </td>
                                <td>{{record.cashname}}</td>
                                <td>{{ record.description }}</td>
                                <td  class="text-center" [class.text-red]="record.paid < 0">{{ record.paid | currency:'EUR':true }}</td>
                                <td  class="text-center" [class.text-red]="record.amount < 0">{{ record.amount | currency:'EUR':true }}</td>
                                <td class="text-center">
                                    <small>
                                        <div class="text-truncate mw-100">{{record.username}}</div>
                                        <div *ngIf="record.shopname" class="badge border mw-100 text-truncate"><i class="fa-store-alt fas mr-1"></i><b>{{record.shopname}}</b></div>
                                    </small>
                                </td>
                                <td>
                                    <a *ngIf="mode!='modal'" (click)="openDetail(record)"  title="Modifica / Vedi" class="btn btn-secondary btn-xs float-right">
                                    
                                        <i class="fas fa-pencil-alt"></i>
                                    </a>

                                    <!--<button type="button" class="btn btn-success btn-xs float-right" (click)="openCashflowDetail(record)"><i class="fa fa-coins"></i></button>-->
                                    <button type="button"  *ngIf="mode=='modal'" class="btn btn-secondary btn-xs float-right" (click)="selectRecord(record);">
                                        <span class="d-none d-sm-inline-block m-1">Seleziona</span><i class="fas fa-chevron-right"></i>
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                        <tfoot>
                            <tr>                                
                                <td colspan="4">
                                    <b>TOTALE</b>
                                </td>
                                <td class="text-center">
                                    <b>{{total_paid | currency:'EUR':true }}</b>
                                </td>
                                <td></td>
                                <td></td>
                            </tr>
                        </tfoot>
                    </table>
                </form>
                <div class="card-footer clearfix py-1" *ngIf="mode!='embedded'">
                    <app-pagination [model]="this" ></app-pagination>
                </div>
            </div>
        </div>
    </div>
</app-windowlist>